export const articles = [
  {
    id: '1',
    slug: 'dingliu-nanyixing-shenye-yuehui-baoguang',
    title: '某顶流男艺人深夜密会神秘女子，疑似新恋情曝光',
    excerpt: '据知情人士透露，该男艺人近期频繁与一名圈外女子出入高档餐厅，举止亲密引发猜测。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20upscale%20restaurant%20interior%20at%20night%2C%20two%20silhouettes%20sitting%20at%20a%20corner%20table%2C%20warm%20ambient%20lighting%2C%20mysterious%20atmosphere%2C%20paparazzi%20style%20photography%2C%20cinematic%20composition%2C%20dark%20background%20with%20soft%20bokeh%20lights%2C%20elegant%20setting%2C%20editorial%20mood&width=800&height=600&seq=article-01-2026&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20upscale%20restaurant%20interior%20at%20night%2C%20two%20silhouettes%20sitting%20at%20a%20corner%20table%2C%20warm%20ambient%20lighting%2C%20mysterious%20atmosphere%2C%20paparazzi%20style%20photography%2C%20cinematic%20composition%2C%20dark%20background%20with%20soft%20bokeh%20lights%2C%20elegant%20setting%2C%20editorial%20mood&width=200&height=200&seq=article-01-2026-thumb&orientation=squarish',
    content: `
      <p>近日，有网友爆料称在某高档日料餐厅偶遇当红男艺人李某某与一名神秘女子共进晚餐。据目击者描述，两人席间举止亲密，不时低声交谈，氛围暧昧。</p>
      <p>消息人士透露，该女子并非圈内人士，而是一名金融行业从业者，两人相识已有一段时间。李某某工作室暂未对此事作出回应。</p>
      <p>值得注意的是，李某某此前曾在公开采访中表示"目前以事业为重，暂不考虑感情问题"。此番被拍到与女性友人密会，让不少粉丝感到震惊。</p>
      <p>有网友扒出该女子社交账号，发现其曾在多个场合与李某某出现在同一地点，时间线高度重合，更加坐实了两人关系非同一般的猜测。</p>
      <p>目前该话题已登上热搜榜首，阅读量突破3亿。粉丝态度两极分化，有人送上祝福，也有人表示难以接受。</p>
    `,
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    author: '吃瓜前线',
    publishedAt: '2026-06-30T22:15:00',
    views: 285000,
    comments: 3420,
    hotIndex: 98,
    tags: ['顶流塌房', '恋情曝光'],
  },
  {
    id: '2',
    slug: 'zhiming-wanghong-zhibo-fanche-xianchang',
    title: '知名带货网红直播翻车，千万粉丝见证尴尬瞬间',
    excerpt: '拥有千万粉丝的头部主播在最新直播中产品演示失败，场面一度十分尴尬，引发全网热议。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20streaming%20studio%20with%20ring%20lights%20and%20products%20on%20display%2C%20a%20surprised%20female%20streamer%20expression%2C%20dramatic%20lighting%2C%20live%20broadcast%20setup%2C%20modern%20internet%20culture%20aesthetic%2C%20bright%20pink%20and%20white%20color%20scheme%2C%20editorial%20photography%20style%2C%20clean%20background&width=800&height=600&seq=article-02-2026&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=A%20streaming%20studio%20with%20ring%20lights%20and%20products%20on%20display%2C%20a%20surprised%20female%20streamer%20expression%2C%20dramatic%20lighting%2C%20live%20broadcast%20setup%2C%20modern%20internet%20culture%20aesthetic%2C%20bright%20pink%20and%20white%20color%20scheme%2C%20editorial%20photography%20style%2C%20clean%20background&width=200&height=200&seq=article-02-2026-thumb&orientation=squarish',
    content: `
      <p>昨晚，拥有超过1500万粉丝的知名带货主播"小美酱"在直播间推销一款美容仪时发生翻车事故。在演示产品功效时，仪器突然冒烟，吓得主播当场尖叫后退。</p>
      <p>直播间弹幕瞬间炸裂，在线观看人数从80万飙升至200万。不少网友表示"这是今年看过最真实的直播"。事后该产品品牌方紧急发布声明称系个别产品故障，已启动全面召回。</p>
      <p>这已经不是小美酱第一次直播翻车。上个月她推荐的某款减肥产品也被消费者投诉效果虚假，引发过一轮争议。</p>
      <p>业内人士分析认为，头部主播选品不严格、一味追求高佣金的模式正在透支消费者信任，此次事件可能成为行业整顿的导火索。</p>
    `,
    category: '网红翻车',
    categorySlug: 'wanghong-fanche',
    author: '黑料挖掘机',
    publishedAt: '2026-06-30T18:30:00',
    views: 567000,
    comments: 8920,
    hotIndex: 96,
    tags: ['直播翻车', '直播带货'],
  },
  {
    id: '3',
    slug: 'zongyi-jie-muxuan-heimu-jiepi',
    title: '综艺节目选秀黑幕大揭秘：内定冠军早有预谋',
    excerpt: '前选秀节目工作人员匿名爆料，揭秘节目组如何操控投票结果，内定冠军选手。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20backstage%20area%20of%20a%20TV%20studio%20with%20stage%20lights%20in%20the%20distance%2C%20dramatic%20shadows%2C%20mysterious%20atmosphere%2C%20behind%20the%20scenes%20vibe%2C%20cinematic%20composition%2C%20dark%20and%20moody%20lighting%2C%20editorial%20photography&width=800&height=600&seq=article-03-2026&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=A%20dark%20backstage%20area%20of%20a%20TV%20studio%20with%20stage%20lights%20in%20the%20distance%2C%20dramatic%20shadows%2C%20mysterious%20atmosphere%2C%20behind%20the%20scenes%20vibe%2C%20cinematic%20composition%2C%20dark%20and%20moody%20lighting%2C%20editorial%20photography&width=200&height=200&seq=article-03-2026-thumb&orientation=squarish',
    content: `
      <p>一位自称曾在某大型选秀节目工作过的匿名人士向本网爆料，揭露了节目组操控比赛结果的内幕。</p>
      <p>据其透露，节目组在录制前就已经确定了最终的冠军人选，所有环节的"观众投票"实际上都由节目组后台操控。某些选手的票数会在直播中被实时调整，以确保剧情按照预设方向发展。</p>
      <p>更令人震惊的是，节目组还会故意剪辑某些选手的负面镜头，引导观众对其产生反感，从而为"预定冠军"扫清障碍。</p>
      <p>该爆料人士表示："我实在看不下去那些真正有实力的选手被淘汰，所以选择站出来说出真相。"</p>
    `,
    category: '黑料深度',
    categorySlug: 'he-liao-shendu',
    author: '匿名爆料人',
    publishedAt: '2026-06-29T14:00:00',
    views: 723000,
    comments: 12560,
    hotIndex: 94,
    tags: ['综艺争议', '选秀黑幕'],
  },
  {
    id: '4',
    slug: 'nv-mingxing-hongtan-zhaoxing-pijing-tupian',
    title: '某女星红毯造型翻车？网友：这是披了块抹布出门吗',
    excerpt: '某知名女星出席时尚活动红毯造型引发群嘲，被网友戏称为"年度最灾难造型"。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fashionable%20red%20carpet%20event%20scene%20with%20photographers%20and%20bright%20flashes%2C%20glamorous%20atmosphere%2C%20luxury%20fashion%20event%2C%20elegant%20indoor%20venue%2C%20editorial%20photography%20with%20soft%20glam%20lighting%2C%20high%20end%20aesthetic&width=800&height=600&seq=article-04-2026&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=A%20fashionable%20red%20carpet%20event%20scene%20with%20photographers%20and%20bright%20flashes%2C%20glamorous%20atmosphere%2C%20luxury%20fashion%20event%2C%20elegant%20indoor%20venue%2C%20editorial%20photography%20with%20soft%20glam%20lighting%2C%20high%20end%20aesthetic&width=200&height=200&seq=article-04-2026-thumb&orientation=squarish',
    content: `
      <p>昨晚的某时尚颁奖典礼红毯环节，知名女星张某某以一袭"前卫"造型亮相，立刻在社交媒体上引发热议。这套由某国际品牌提供的礼服被网友形容为"像披了一块破布"。</p>
      <p>时尚博主们纷纷发文点评，有人直言"这是对红毯的侮辱"，也有人表示理解"可能是想尝试突破"。但更多的网友选择了毫不留情的吐槽模式。</p>
      <p>话题"张某某红毯翻车"迅速登上热搜，阅读量在两小时内突破2亿。不少网友翻出该女星过去的经典红毯造型作对比，形成鲜明反差。</p>
    `,
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    author: '时尚警察',
    publishedAt: '2026-06-29T10:00:00',
    views: 198000,
    comments: 2340,
    hotIndex: 88,
    tags: ['红毯翻车', '时尚话题'],
  },
  {
    id: '5',
    slug: 'wangluo-zhubo-qianwan-pianju-qiankuan',
    title: '某游戏主播涉嫌诈骗粉丝千万，已被警方立案调查',
    excerpt: '以"投资理财"为名诱骗粉丝投入巨额资金，受害人数超过200人，涉案金额惊人。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20computer%20gaming%20room%20with%20RGB%20lighting%2C%20empty%20gaming%20chair%2C%20dim%20atmosphere%2C%20mysterious%20and%20suspenseful%20mood%2C%20abandoned%20streaming%20setup%2C%20cinematic%20composition%2C%20dark%20and%20dramatic%20lighting%2C%20editorial%20photography&width=800&height=600&seq=article-05-2026&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=A%20dark%20computer%20gaming%20room%20with%20RGB%20lighting%2C%20empty%20gaming%20chair%2C%20dim%20atmosphere%2C%20mysterious%20and%20suspenseful%20mood%2C%20abandoned%20streaming%20setup%2C%20cinematic%20composition%2C%20dark%20and%20dramatic%20lighting%2C%20editorial%20photography&width=200&height=200&seq=article-05-2026-thumb&orientation=squarish',
    content: `
      <p>据可靠消息，知名游戏主播"阿龙"因涉嫌以虚假投资理财项目诈骗粉丝，已被当地警方立案侦查。初步统计受害粉丝超过200人，涉案金额高达千万元。</p>
      <p>多名受害者在社交平台发文控诉，称该主播利用粉丝对其的信任，以"内部渠道""稳赚不赔"等话术诱导粉丝投资，最终资金去向不明。</p>
      <p>目前该主播的所有社交账号已处于停更状态，工作室大门紧闭。警方呼吁更多受害者站出来提供线索。</p>
    `,
    category: '网红翻车',
    categorySlug: 'wanghong-fanche',
    author: '黑料挖掘机',
    publishedAt: '2026-06-28T20:00:00',
    views: 891000,
    comments: 15670,
    hotIndex: 92,
    tags: ['直播翻车', '粉丝诈骗'],
  },
  {
    id: '6',
    slug: 'shuangren-zuhe-neihong-buhe-neimu',
    title: '某双人组合疑似内部不和，经纪人证实已半年无交流',
    excerpt: '曾经亲密无间的双人组合被曝私下早已形同陌路，各自发展互不往来。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stage%20performance%20scene%20with%20two%20performers%20facing%20opposite%20directions%2C%20dramatic%20split%20lighting%2C%20concert%20atmosphere%2C%20tension%20and%20distance%20between%20them%2C%20cinematic%20composition%2C%20dramatic%20spotlight%20effect%2C%20editorial%20photography&width=800&height=600&seq=article-06-2026&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=A%20stage%20performance%20scene%20with%20two%20performers%20facing%20opposite%20directions%2C%20dramatic%20split%20lighting%2C%20concert%20atmosphere%2C%20tension%20and%20distance%20between%20them%2C%20cinematic%20composition%2C%20dramatic%20spotlight%20effect%2C%20editorial%20photography&width=200&height=200&seq=article-06-2026-thumb&orientation=squarish',
    content: `
      <p>曾被誉为"最佳搭档"的某双人组合近期被曝出内部不合传闻。据其前经纪人独家向本网透露，两人实际上已有半年多没有任何私下交流，所有的同台演出都只是"商业合作"。</p>
      <p>该经纪人表示："他们现在连化妆间都要分开，演出结束立刻各走各的。粉丝看到的'兄弟情深'全都是演出来的。"</p>
      <p>消息一出，粉丝群体立即分裂为两派，互相指责是对方偶像的问题。两人的社交平台评论区已经沦为粉丝骂战的战场。</p>
    `,
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    author: '吃瓜前线',
    publishedAt: '2026-06-28T15:00:00',
    views: 345000,
    comments: 5670,
    hotIndex: 85,
    tags: ['组合不合', '内部爆料'],
  },
  {
    id: '7',
    slug: 'fancha-nvshen-richang-shenghuo-jilupian',
    title: '反差感拉满！高冷女神的日常生活竟然是这样的',
    excerpt: '镜头前高冷优雅的某女艺人，私下生活状态曝光，巨大反差让网友直呼"判若两人"。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cozy%20home%20interior%20with%20a%20cat%2C%20casual%20and%20relaxed%20atmosphere%2C%20warm%20natural%20lighting%2C%20comfortable%20living%20room%20setting%2C%20candid%20lifestyle%20photography%2C%20soft%20and%20inviting%20aesthetic%2C%20editorial%20style%20with%20natural%20composition&width=800&height=600&seq=article-07-2026&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=A%20cozy%20home%20interior%20with%20a%20cat%2C%20casual%20and%20relaxed%20atmosphere%2C%20warm%20natural%20lighting%2C%20comfortable%20living%20room%20setting%2C%20candid%20lifestyle%20photography%2C%20soft%20and%20inviting%20aesthetic%2C%20editorial%20style%20with%20natural%20composition&width=200&height=200&seq=article-07-2026-thumb&orientation=squarish',
    content: `
      <p>日前，某位以高冷形象著称的女艺人的一段居家视频在网络上流传。视频中的她素颜出镜，穿着卡通睡衣，正蹲在地上逗猫玩耍，与平时红毯上的高冷形象形成强烈反差。</p>
      <p>视频迅速在各大平台传播，网友纷纷表示"原来女神私下这么可爱""这才是真实的她吧"。该女艺人随后大方回应称"谁还没个在家邋遢的时候呢"，坦诚态度反而赢得更多好感。</p>
      <p>娱乐圈人设与真实人格的反差一直是网友们津津乐道的话题。此次事件再次证明，真实的艺人往往比精心包装的人设更受欢迎。</p>
    `,
    category: '反差视频',
    categorySlug: 'fancha-shipin',
    author: '反差观察员',
    publishedAt: '2026-06-27T12:00:00',
    views: 156000,
    comments: 1890,
    hotIndex: 78,
    tags: ['反差视频', '女神日常'],
  },
  {
    id: '8',
    slug: 'jinri-dasai-dingliu-nanxing-yanyi-paiming',
    title: '今日大赛：顶流男星演技大比拼，谁能称王？',
    excerpt: '每日大赛今日话题——谁才是真正的演技派？粉丝投票已突破50万，战况激烈。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20film%20set%20with%20dramatic%20cinematic%20lighting%2C%20movie%20production%20atmosphere%2C%20directors%20chair%20and%20camera%20equipment%2C%20professional%20film%20industry%20setting%2C%20warm%20stage%20lights%2C%20editorial%20photography%2C%20behind%20the%20scenes%20movie%20aesthetic&width=800&height=600&seq=article-08-2026&orientation=landscape',
    thumbImage: 'https://readdy.ai/api/search-image?query=A%20film%20set%20with%20dramatic%20cinematic%20lighting%2C%20movie%20production%20atmosphere%2C%20directors%20chair%20and%20camera%20equipment%2C%20professional%20film%20industry%20setting%2C%20warm%20stage%20lights%2C%20editorial%20photography%2C%20behind%20the%20scenes%20movie%20aesthetic&width=200&height=200&seq=article-08-2026-thumb&orientation=squarish',
    category: '每日大赛',
    categorySlug: 'meiri-dasai',
    author: '大赛主持',
    publishedAt: '2026-06-30T08:00:00',
    views: 512000,
    comments: 23400,
    hotIndex: 99,
    tags: ['每日大赛', '顶流男星'],
  },
];

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter(a => a.categorySlug === categorySlug);
};

export const getArticleById = (id: string) => {
  return articles.find(a => a.id === id);
};

export const getHotArticles = (limit: number = 6) => {
  return [...articles].sort((a, b) => b.hotIndex - a.hotIndex).slice(0, limit);
};

export const getLatestArticles = (limit: number = 8) => {
  return [...articles].sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()).slice(0, limit);
};